import React from "react";

import { Link } from 'react-router-dom';
import DiscoverSection from "../components/Discover";
import TechnomindsSection from "../components/Technominds";
import MissionSection from "../components/Ourdata";
import ReasonSection from "../components/Reason";
import ReviewSection from "../components/Review";



const AboutUspage = () => {



const discoverData = {
    heading: "Discover Our Journey and Meet the Experts",
    description: "Explore the story behind Techno Inspector and get to know the dedicated team that ensures your peace of mind with every inspection.",
    points: [
        {
            icon: "fa-solid fa-suitcase-medical",
            text: "Why Choose Us?"
        },
        {
            icon: "fa-solid fa-flag-usa",
            text: "Why Choose Us?"
        }
    ],
    linkText: "Learn More",
    linkUrl: "/mold-inspections",
    image: "./images/about1.webp"
};


const technomindsData = {
    image: "./images/technominds.webp", 
    heading: "Why choose Technominds?",
    description: "We, at Technominds, inspect properties using the most skilled minds and sophisticated tools.",
    topPoints: [
        "We are fully qualified Registered Home Inspectors",
        "We are well Insured to protect you",
        "Follow Nationally and Provincially accepted Standards of Practice",
        "Member of Ontario Association of Home Inspectors",
        "Member of the Canadian Association of Home and Property Inspectors",
        "Mold/IAQ Certified, IAC2 Certified",
        "We are extremely thorough, Impartial, and independent",
        "Honest, Integral, and professional"
    ],
    bottomPoints: [
        "Detailed, unbiased, and easy-to-read and understand reports",
        "Convenient scheduling, we work exclusively for the customer",
        "We provide you electronic inspection report with pictures and thoroughly explain the report findings at the time of inspection. Our reports are detailed, unbiased, and easy to read and understand.",
        "In addition to reporting any deficiencies or potential failures, our inspections include maintenance tips and other educational information."
    ],
    contactText: "Call us at 416 500 1535 to book an inspection, or in case you want to know more about our services."
};


const missionData = {
    subtitle: "Our Mission",
    heading: "Your Trusted Source for Honest Home Inspection & Review",
    description: `Technominds (Home & Mold) Inspection Services team provides valuable property inspection services in Toronto, Mississauga, Brampton, and other nearby areas. Our color pictures/video reports are renowned in the Ontario real estate industry and have helped thousands of homeowners realize their dream homes. Technominds Home Inspection report is an unbiased and independent report on the actual physical systems, structures, and components of the property. Our customers expect nothing less than true professionalism, credentials, competence, and courtesy from our staff. A detailed property inspection takes around 2-3 hours and depends on the home’s square footage and age.`,
    note: "Proud Members Of"
};


const logoData = [
  "/images/logo1.png",
  "/images/logo2.png",
  "/images/logo3.png",
  "/images/logo4.png",
  "/images/logo5.png",
  "/images/logo6.png"
];


const reviewData = {
  title: "Get Started Today",
  paragraph: `Ready to experience the Techno Inspector difference? Whether you’re a homeowner looking to safeguard your investment or a real estate agent seeking reliable inspection services, we’re here to help. Contact our team today to schedule your inspection and take the first step towards a more informed future. Our experts are just a click away, ready to provide the insights you need.`,
  linkText: "Schedule Your Inspection",
  linkUrl: "/commercial" 
};



  return (
    <>
      <div class="about-page-002 common-001">
        <section className="section-banner">
          <div className="container">
            <div className="inner-content">
              <p>Fast, Reliable Home Inspections for Agents & Homeowners</p>
              <h1>
                About<span> Us</span>
              </h1>
              <p>
                Discover peace of mind with our expert home inspection services,
                designed to meet the needs of both real estate agents and
                property owners. Our team ensures thorough evaluations and
                prompt reporting, helping you make informed decisions.
              </p>
              <div className="dft-btn">
                <Link to="/industerial-building" className="btn">
                  For Inspection Services
                </Link>
              </div>
            </div>
          </div>
        </section>



 {/* <DiscoverSection discoverData={discoverData} /> */}

 <TechnomindsSection technomindsData={technomindsData} />

 <MissionSection missionData={missionData} />

 <ReasonSection logos={logoData} />

 <ReviewSection content={reviewData} />

      </div>
    </>
  );
};

export default AboutUspage;
